import React, { useEffect, useState } from "react"
import { GridStack } from "gridstack";
import { useTranslation } from 'react-i18next';
import { useLocation } from "react-router-dom";
import DMSHeader from "../DMSHeader/DMSHeader";
import GridItem from "../../../Components/UiComponents/GridItem/GridItem";
import AccidentViewer from "./AccidentViewer";
import DisasterViewer from "./AccidentViewer";

const AccidentViewerHeader = () => {
    const { t } = useTranslation();
    const { state } = useLocation();
    const [currentTab, setCurrentTab] = useState('create');
    const [isEditMode, setIsEditMode] = useState(false);
    let edit = state?.edit;
    let data = state?.data;

    useEffect(() => {
        GridStack.init();

        // Set edit mode if edit state is present
        if (edit && data) {
            setIsEditMode(true);
            setCurrentTab('assign');
        }
    }, [edit, data]);

   

    // Determine header title based on current tab and edit mode
    const getHeaderTitle = () => {
        if (isEditMode && currentTab === 'assign') {
            return t("Edit Assigned Route");
        }

        switch (currentTab) {
            case 'create':
                return t("Acknowledge Disaster");
            case 'assign':
                return t("Assign Route");
            case 'list':
                return t("Route List");
            default:
                return t("Acknowladge Disaster");
        }
    };

    const layoutData = [
        {
            x: 0,
            y: 0,
            width: 12,
            height: 1,
            id: 0,
            component: (
                <DMSHeader
                    title={getHeaderTitle()}
                    showIconsForback={true}
                />
            ),
            haveOverflowVisible: true,
        },
        {
            x: 0,
            y: 1,
            width: 12,
            height: 13,
            id: 1,
            component: (
                <DisasterViewer
                    // onTabChange={handleTabChange}
                    // onEditModeChange={handleEditModeChange}
                />
            ),
            haveOverflowVisible: true,
        },
    ];

    return (
        <div className="grid-stack grid-stack-instance-1 smartpole__header--transition ">
            <GridItem layoutData={layoutData} />
        </div>
    );
}

export default AccidentViewerHeader;